<template>
  <div v-bind:class="bodyClassObject">
    <div class="wrapper">
      <HeaderComponent></HeaderComponent>
      <MenuComponent active="programs"></MenuComponent>
      <SportProgramContentComponent
        v-bind:sport-program="sportProgram"
        v-bind:sport-types="sportTypes"
        v-bind:countries="countries"
        v-bind:cities="cities">
      </SportProgramContentComponent>
      <FooterComponent></FooterComponent>
      <AlertComponent></AlertComponent>
    </div>
  </div>
</template>

<script>
import MenuComponent from './Menu';
import HeaderComponent from './Header';
import SportProgramContentComponent from './SportProgramContent';
import FooterComponent from './Footer';
import AlertComponent from './Alert';
import axios from 'axios';

export default {
  name: 'SportProgram',
  data () {
    return {
      sportProgram: {},
      countries: [],
      cities: [],
      sportTypes: []
    };
  },
  props: {
    id: String
  },
  created () {
    let self = this;

    self.sportProgram = null;
    self.countries = [];
    self.sportTypes = [];
    self.cities = [];

    self.fetchData();

    self.$root.$on('updateTraining', function () {
      self.fetchData();
    });
  },
  components: {
    MenuComponent,
    HeaderComponent,
    FooterComponent,
    AlertComponent,
    SportProgramContentComponent
  },
  computed: {
    bodyClassObject: function () {
      return {
        'skin-blue': window.application === 'cabinet',
        'skin-green': window.application !== 'cabinet'
      };
    }
  },
  methods: {
    fetchData: function () {
      let self = this;

      axios.get(
        window.host + '/trainings/' + this.id)
        .then(function (response) {
          console.log(response.data);
          self.sportProgram = response.data;

          axios.get(
            window.host + '/countries/' + self.sportProgram.location.countryId + '/cities')
            .then(function (r) {
              console.log(r.data);
              self.cities = r.data;
            })
            .catch(function (er) {
              console.log(er);
            });
        })
        .catch(function (error) {
          console.log(error);
        });

      axios.get(
        window.host + '/countries')
        .then(function (response) {
          self.countries = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });

      axios.get(
        window.host + '/sportTypes')
        .then(function (response) {
          self.sportTypes = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>

</style>
